import React from "react";

export const styles = {
    page: {
        padding: "10px",
    },
    card: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "30px",
    },
    topHeader: {
        width: "100%",
        marginBottom: "10px",
    },
    headerRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "2px",
    },
    headerLabel: {
        fontSize: "16px",
        color: "#333",
        fontWeight: 700,
    } as React.CSSProperties,
    statusBadge: {
        display: "inline-block",
        padding: "6px 16px",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: 600,
        textTransform: "uppercase" as const,
    } as React.CSSProperties,
    statusOpen: {
        backgroundColor: "#E3F2FD",
        color: "#1976D2",
    } as React.CSSProperties,
    statusPendingReview: {
        backgroundColor: "#FFF9E6",
        color: "#E5B611",
    } as React.CSSProperties,
    statusApproved: {
        backgroundColor: "#E8F5E9",
        color: "#4CAF50",
    } as React.CSSProperties,
    statusWIP: {
        backgroundColor: "#FFF3E0",
        color: "#FF9800",
    } as React.CSSProperties,
    statusCompleted: {
        backgroundColor: "#E8F5E9",
        color: "#2E7D32",
    } as React.CSSProperties,
    description: {
        fontSize: "12px",
        color: "#666",
        lineHeight: 1.5,
        margin: 0,
    } as React.CSSProperties,
    mainWrapper: {
        display: "flex",
        alignItems: "stretch",
        gap: "30px",
    } as React.CSSProperties,
    leftSection: {
        width: "25%",
    } as React.CSSProperties,
    sectionHeading: {
        fontSize: "14px",
        fontWeight: 600,
        color: "#333",
        marginBottom: "8px",
        marginTop: 0,
    } as React.CSSProperties,
    ticketInfo: {
        marginBottom: "8px",
    } as React.CSSProperties,
    infoRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "4px",
        gap: "8px",
    } as React.CSSProperties,
    infoGroup: {
        marginBottom: "8px",
    } as React.CSSProperties,
    infoLabel: {
        fontSize: "12px",
        color: "#999",
        fontWeight: 500,
        display: "block",
    } as React.CSSProperties,
    infoValue: {
        fontSize: "12px",
        color: "#333333",
        fontWeight: 500,
        display: "block",
        wordBreak: "break-word" as const,
    } as React.CSSProperties,
    horizontalDivider: {
        height: "1px",
        backgroundColor: "#F2F2F2",
        margin: "5px 0",
    } as React.CSSProperties,
    horizontalHeaderDivider: {
        height: "1px",
        backgroundColor: "#F2F2F2",
        margin: "15px 0",
    } as React.CSSProperties,
    requestedByInfo: {
        marginBottom: "5px",
    } as React.CSSProperties,
    assignButton: {
        width: "100%",
        padding: "10px 16px",
        marginTop: "8px",
        fontSize: "14px",
        fontWeight: 500,
        color: "#C6C7C8",
        backgroundColor: "#FFFFFF",
        border: "1px solid #C6C7C8",
        borderRadius: "6px",
        cursor: "not-allowed" as const,
        transition: "all 0.2s ease",
    },
    assignButtonEnabled: {
        color: "#E5B611",
        borderColor: "#E5B611",
        cursor: "pointer" as const,
    },
    verticalDivider: {
        width: "1px",
        backgroundColor: "#F2F2F2",
        alignSelf: "stretch" as const,
    },
    rightSection: {
        width: "75%",
    } as React.CSSProperties,
    stepperWrapper: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginBottom: "30px",
    } as React.CSSProperties,
    stepItem: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
        flex: 1,
    },
    stepCircle: {
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: 600,
        marginBottom: "12px",
    } as React.CSSProperties,
    stepCircleCompleted: {
        backgroundColor: "#E5B611",
        border: "2px solid #E5B611",
        boxShadow: "0 0 0 3px #fff, 0 0 0 5px #E5B611",
    } as React.CSSProperties,

    stepCircleActive: {
        backgroundColor: "#E5B611",
        border: "2px solid #E5B611",
        boxShadow: "0 0 0 3px #fff, 0 0 0 5px #E5B611",
    } as React.CSSProperties,
    stepCirclePending: {
        backgroundColor: "#FFFFFF",
        border: "2px solid #E0E0E0",
    } as React.CSSProperties,
    stepNumber: {
        color: "#999",
    } as React.CSSProperties,
    stepNumberActive: {
        color: "#FFF",
    } as React.CSSProperties,
    stepLabel: {
        textAlign: "center" as const,
        maxWidth: "130px",
    },
    stepTitle: {
        fontSize: "12px",
        fontWeight: 600,
        color: "#999",
        marginBottom: "4px",
    } as React.CSSProperties,
    stepTitleActive: {
        color: "#000",
    } as React.CSSProperties,
    connectorWrapper: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        marginTop: "20px",
    } as React.CSSProperties,
    connectorLine: {
        backgroundColor: "transparent",
        backgroundImage: "repeating-linear-gradient(90deg, #CBD5E1 0px, #CBD5E1 6px, transparent 6px, transparent 12px)",
        height: "1px",
        width: "100%",
    } as React.CSSProperties,
    connectorProgress: {
        height: "100%",
        backgroundColor: "#E5B611",
        transition: "width 0.4s ease",
    } as React.CSSProperties,
    rejectSection: {
        backgroundColor: "#F7F8FA",
        borderRadius: "8px",
        padding: "24px",
        marginTop: "20px",
        border: "1px solid #FEE",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    } as React.CSSProperties,
    rejectContent: {
        flex: 1,
    } as React.CSSProperties,
    rejectHeading: {
        fontSize: "14px",
        fontWeight: 600,
        margin: "0 0 8px 0",
    } as React.CSSProperties,
    rejectText: {
        fontSize: "12px",
        color: "#666",
        margin: 0,
        lineHeight: 1.5,
    } as React.CSSProperties,
    actionButtonGroup: {
        display: "flex",
        gap: "12px",
        alignItems: "center",
    } as React.CSSProperties,
    rejectButton: {
        padding: "10px 24px",
        fontSize: "14px",
        fontWeight: 500,
        color: "#E01F29",
        backgroundColor: "transparent",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        whiteSpace: "nowrap" as const,
    } as React.CSSProperties,
    approveButton: {
        padding: "10px 24px",
        fontSize: "14px",
        fontWeight: 500,
        color: "#000",
        backgroundColor: "#E5B611",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        whiteSpace: "nowrap" as const,
    } as React.CSSProperties,
    assignmentCard: {
        backgroundColor: "#F7F8FA",
        borderRadius: "8px",
        padding: "24px",
        marginTop: "20px",
    } as React.CSSProperties,
    assignmentHeading: {
        fontSize: "14px",
        fontWeight: 600,
        color: "#333",
        margin: "0 0 12px 0",
    } as React.CSSProperties,
    assignmentText: {
        fontSize: "14px",
        color: "#666",
        margin: "0 0 20px 0",
        lineHeight: 1.5,
    } as React.CSSProperties,
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "400px",
        fontSize: "16px",
        color: "#666",
    } as React.CSSProperties,
    errorContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "400px",
        fontSize: "16px",
        color: "#e74c3c",
    } as React.CSSProperties,
    filterGroup: {
        display: "flex",
        flexDirection: "column" as "column",
        gap: 4,
        minWidth: 250
    },
    searchInput: {
        fontSize: 12,
        padding: "8px 12px",
        border: "1px solid #E3E6EA",
        borderRadius: 4,
        outline: "none",
        width: "100%",
        boxSizing: "border-box" as const,
    },
    noResults: {
        fontSize: 12,
        padding: "12px 16px",
        color: "#999",
        textAlign: "center" as const,
    },
    assignToSelfOption: {
        fontSize: 12,
        padding: "10px 16px",
        cursor: "pointer",
        backgroundColor: "#FFF9E6",
        color: "#E5B611",
        fontWeight: 600,
        borderBottom: "2px solid #E5B611",
        display: "flex",
        alignItems: "center",
        gap: "8px",
    } as React.CSSProperties,
    modalOverlay: {
        position: "fixed" as const,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "24px",
        width: "90%",
        maxWidth: "500px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    } as React.CSSProperties,
    modalHeader: {
        fontSize: "14px",
        fontWeight: 600,
        color: "#333",
        marginBottom: "16px",
    } as React.CSSProperties,
    modalLabel: {
        fontSize: "14px",
        fontWeight: 500,
        color: "#333",
        marginBottom: "8px",
        display: "block",
    } as React.CSSProperties,
    modalTextarea: {
        width: "100%",
        minHeight: "120px",
        padding: "12px",
        fontSize: "14px",
        border: "1px solid #D1D5DB",
        borderRadius: "6px",
        resize: "vertical" as const,
        fontFamily: "inherit",
        boxSizing: "border-box" as const,
        outline: "none",
    } as React.CSSProperties,
    modalButtonGroup: {
        display: "flex",
        gap: "12px",
        justifyContent: "flex-end",
        marginTop: "20px",
    } as React.CSSProperties,
    modalCancelButton: {
        padding: "10px 24px",
        fontSize: "14px",
        fontWeight: 500,
        color: "#666",
        backgroundColor: "#fff",
        border: "1px solid #D1D5DB",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "all 0.2s ease",
    } as React.CSSProperties,
    modalSubmitButton: {
        padding: "10px 24px",
        fontSize: "14px",
        fontWeight: 500,
        color: "#fff",
        backgroundColor: "#DC2626",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        transition: "all 0.2s ease",
    } as React.CSSProperties,
    buttonDisabled: {
        opacity: 0.6,
        cursor: "not-allowed" as const,
    } as React.CSSProperties,
    radioGroup: {
        display: "flex",
        gap: "16px",
        marginBottom: "12px",
        alignItems: "center",
    },
    radioLabel: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontSize: 13,
        color: "#374151",
        userSelect: "none" as const,
    },
    radioInput: {
        accentColor: "#E3AF32",
        cursor: "inherit",
        width: 14,
        height: 14,
    },
} as const;